<template>
  <div>
    <div class="Ozg Padding">Краткое описание «{{ card.name_big }}»</div>
  </div>
</template>

<script>
export default {
  props: {
    card: { type: Object, default: function() { return {}; } },
  },
};
</script>
